import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles((theme) => ({
  title: {
    fontSize: "1.4rem",
  },
  textGray: {
    color: "#898989",
  },
  dot: {
    fontSize: "8px",
    marginLeft: "10px",
    marginRight: "10px",
  },
  card: {
    // maxWidth: "527px",
    minHeight: "80px",
    display: "flex",
    alignItems: "center",
    paddingLeft: theme.spacing(2),
  },
}))

export default styles
